// import React, { useEffect, useState } from "react";
// import {
//     Box,
//     Grid,
//     Typography,
//     Paper,
//     IconButton,
//     Tooltip,
// } from "@mui/material";
// import SaveIcon from "@mui/icons-material/Save";
// import { useForm } from "react-hook-form";

// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import { useNavigate, useParams } from "react-router-dom";
// import  config from "../../../Config/clientConfig.json"
// import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

// interface Item {
//     ItemId: string;
//     ItemName: string;
//     ItemCode: string;
//     IsActive: boolean;
// }

// interface Warehouse {
//     WarehouseId: string;
//     WarehouseName: string;
//     Location: string;
//     IsActive: boolean;
// }

// interface StockReturnData {
//     ItemId: string;
//     WarehouseId: string;
//     Quantity: number;
//     ReturnType: string;
//     Remarks: string;

// }

// const StockReturn = () => {
//    const [loading, setLoading] = useState(false);
//        const [isEditMode, setIsEditMode] = useState(false);
//        const [selectedId, setSelectedId] = useState<string | number>(0);
//        const [isPopupOpen, setPopupOpen] = useState(false);
//        const { showMessage } = useSnackbar();
//        const params = useParams();
//        const id = params.id;
//        const navigate = useNavigate();

//        // ✅ Properly typed state
//        const [items, setItems] = useState<Item[]>([]);
//        const [warehouses, setWarehouses] = useState<Warehouse[]>([]);

//        const {
//            control,
//            handleSubmit,
//            reset,
//            formState: { isValid },
//        } = useForm({
//            mode: "onChange",
//            defaultValues: {
//                ItemId: "",
//                WarehouseId: "",
//                Quantity: "",
//                ReturnType:"",
//                Remarks:""

//            },
//        });

//         const fetchDropdownData = async () => {
//                try {
//                    const [itemsRes, warehousesRes] = await Promise.all([
//                        callAPI("items/list", Method.GET),
//                        callAPI("warehouses/list", Method.GET),
//                    ]);

//                    if (itemsRes?.success) setItems(itemsRes.data.results || []);
//                    if (warehousesRes?.success) setWarehouses(warehousesRes.data.results || []);
//                } catch (error) {
//                    console.error("Failed to fetch dropdown data:", error);
//                }
//            };



//            useEffect(() => {

//                    if (!id || id === "undefined" || id === "null" || id.trim() === "") {
//                        setIsEditMode(false);
//                        reset();
//                        fetchDropdownData();
//                        return;
//                    }

//                    fetchReturnData(id);
//                    fetchDropdownData();
//                }, [id, reset]);

//                const fetchReturnData = async (returnId: string) => {
//                        try {
//                          setLoading(true);

//                          const response = await callAPI(`stockreturn/${returnId}`, Method.GET);

//                          if (response?.success && response.data) {
//                            const returnData = response.data;

//                            reset({
//                              ItemId: returnData.ItemId || "",
//                              WarehouseId: returnData.WarehouseId || "",
//                              Quantity: returnData.Quantity || "",
//                              ReturnType: returnData.ReturnType || "",
//                              Remarks: returnData.Remarks || "",

//                            });
//                          } else {
//                            console.error("❌ No data in response:", response);
//                            showMessage(response?.message || `Supplier ${returnId} not found`, "error");
//                            setIsEditMode(false);
//                          }
//                        } catch (error: any) {
//                          console.error("❌ Fetch error:", error.response?.data || error.message);
//                          showMessage("Failed to load supplier data", "error");
//                          setIsEditMode(false);
//                        } finally {
//                          setLoading(false);
//                        }
//                      };

//            const onSubmit = async (data: any) => {
//                    try {
//                        setLoading(true);
//                        const requestBody: StockReturnData = {
//                            ItemId: data.ItemId || "",
//                            WarehouseId: data.WarehouseId || "",
//                            Quantity: parseInt(data.Quantity) || 0,
//                            ReturnType: data.ReturnType || "",
//                            Remarks: data.Remarks || "",

//                        };


//                        let response;
//                                  if (isEditMode && id) {
//                                 //    response = await callAPI(`stockreturn/${id}`, Method.PUT, requestBody);
//                                 //  } else {
//                                    response = await callAPI("stockreturn", Method.POST, requestBody);
//                                  }

//                                  if (response?.success) {
//                                    showMessage(
//                                      isEditMode ? "stockreturn updated successfully!" : "stockreturn created successfully!", 
//                                      "success"
//                                    );
//                                    navigate("/stock-return/list");
//                                  } else {
//                                    showMessage(response?.message || "Operation failed", "error");
//                                  }
//                                } catch (error: any) {
//                                  console.error("❌ Submit error:", error);
//                                  showMessage(error?.message || "Operation failed", "error");
//                                } finally {
//                                  setLoading(false);
//                                }
//                              };

//                 const handleDeleteClick = () => {
//                if (!id) return;
//                setSelectedId(id);
//                setPopupOpen(true);
//              };



//     return (
//         <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>

//             {}
//             <Box display="flex" justifyContent="space-between" mb={4}>
//                 <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
//                     Stock Return Management
//                 </Typography>

//                 {}
//             </Box>

//             {}
//             <Paper
//                 sx={{
//                     borderRadius: "16px",
//                     p: 3,
//                     background: "#fafafa",
//                 }}
//             >
//                 {}
//                 <Box display="flex" justifyContent="space-between" mb={7}>
//                     <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
//                         Stock Return Details
//                     </Typography>

//                    <Tooltip title={isEditMode ? "Update Verification" : "Create Verification"} arrow>
//             <IconButton
//               sx={{ background: "#000", color: "#fff" }}
//               onClick={handleSubmit(onSubmit)}
//               disabled={!isValid || loading}
//             >
//               <SaveIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//                 </Box>

//                 <Grid container rowSpacing={8} columnSpacing={5}>




//                    <Grid item xs={4}>
//                         <WSSelectField
//                             name="ItemId"
//                             label="Item Name"
//                             id="ItemId"
//                             control={control}
//                             options={items.map(item => ({
//                                 value: item.ItemId,
//                                 label: `${item.ItemCode} - ${item.ItemName}`
//                             }))}
//                         />
//                     </Grid>

//                     {}
//                     <Grid item xs={4}>
//                         <WSSelectField
//                             name="WarehouseId"
//                             label="Warehouse"
//                             id="WarehouseId"
//                             control={control}
//                             options={warehouses.map(warehouse => ({
//                                 value: warehouse.WarehouseId,
//                                 label: warehouse.WarehouseName
//                             }))}
//                         />
//                     </Grid>

//                     {}
//                     <Grid item xs={4}>
//                         <WSTextField
//                             name="Quantity"
//                             label="Quantity"
//                             id="Quantity"
//                             control={control}
//                             type={TextType.AllowOnlyNumber}
//                         />
//                     </Grid>
//                      <Grid item xs={4}>
//                         <WSSelectField
//                             name="ReturnType"
//                             label="ReturnType"
//                             id="ReturnType"
//                             control={control}
//                             options={config.ReturnTypeConfig.staticOptionData}
//                         />
//                     </Grid>

//                     <Grid item xs={4}>
//                         <WSTextField
//                             name="Remarks"
//                             label="Remarks"
//                             id="Remarks"
//                             control={control}
//                         />
//                     </Grid>






//                 </Grid>
//             </Paper>
//          <ConfirmationPopup
//         type="DELETE"
//         apiUrl="stockreturn"
//         id={selectedId}
//         confirmMessage="Are you sure you want to delete this bank?"
//         open={isPopupOpen}
//         onClose={() => setPopupOpen(false)}
//         onConfirm={(data: any) => {
//           if (data.success === true) {
//             showMessage(data?.message, "success");
//           } else {
//            showMessage(data?.detail, "error");
//           }
//         }}
//       />
//         </Box>
//     );
// };

// export default StockReturn;




import React, { useEffect, useState, useRef, useCallback } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    IconButton,
    CircularProgress,
    Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useForm, useWatch } from "react-hook-form";

import WSSelectField from "../../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { callAPI, Method, fetchAllPaginated } from "../../../commonFunctions/CommonFunctions";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../Config/clientConfig.json";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import AddIcon from "@mui/icons-material/Add";


interface Item {
    ItemId: string;
    ItemName: string;
    ItemCode: string;
    IsActive: boolean;
}

interface Warehouse {
    WarehouseId: string;
    WarehouseName: string;
    Location: string;
    IsActive: boolean;
}

interface Technician {
    TechnicianId: string;
    TechnicianName: string;
    Phone: string;
    Email: string;
    IsActive: boolean;
}

interface Customer {
    CustomerId: string;
    CustomerName: string;
}

interface StockReturnData {
    ItemId: string;
    WarehouseId: string;
    TechnicianId: string;
    Quantity: number;
    ReturnType: string;
    Remarks: string;
    SerialNumbers: string[];
}

const StockReturn = () => {
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isScanning, setIsScanning] = useState(false);
    const { showMessage } = useSnackbar();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    const [items, setItems] = useState<Item[]>([]);
    const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
    const [technicians, setTechnicians] = useState<Technician[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { isValid },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            ItemId: "",
            WarehouseId: "",
            TechnicianId: "",
            Quantity: "",
            ReturnType: "",
            Remarks: "",
            SerialNumbers: "",
        },
    });

    const watchedQuantity = useWatch({ control, name: "Quantity" });
    const watchedSerialNumbers = useWatch({ control, name: "SerialNumbers" });


    const fetchAllData = (url: string) => fetchAllPaginated(url);

    const fetchDropdownData = async () => {
    try {
        setLoading(true);

        const [
            allItems,
            allWarehouses,
            allTechnicians,
            allCustomers
        ] = await Promise.all([
            fetchAllData("items/list"),
            fetchAllData("warehouses/list"),
            fetchAllData("technicians/list"),
            fetchAllData("customers/list"),
        ]);

        setItems(allItems);
        setWarehouses(allWarehouses);
        setTechnicians(allTechnicians);
        setCustomers(allCustomers);

    } catch (error) {
        console.error("Failed to fetch dropdown data:", error);
        showMessage("Failed to load dropdown data", "error");
    } finally {
        setLoading(false);
    }
};

    useEffect(() => {
        if (!id || id === "undefined" || id === "null" || id.trim() === "") {
            setIsEditMode(false);
            reset();
            fetchDropdownData();
            return;
        }

        setIsEditMode(true);
        fetchReturnData(id);
        fetchDropdownData();
    }, [id, reset]);

    const fetchReturnData = async (returnId: string) => {
        try {
            setLoading(true);

            const response = await callAPI(`stockreturn/${returnId}`, Method.GET);

            if (response?.success && response.data) {
                const returnData: StockReturnData = response.data;
                reset({
                    ItemId: returnData.ItemId || "",
                    WarehouseId: returnData.WarehouseId || "",
                    TechnicianId: returnData.TechnicianId || "",
                    Quantity: returnData.Quantity?.toString() || "",
                    ReturnType: returnData.ReturnType || "",
                    Remarks: returnData.Remarks || "",
                    SerialNumbers: returnData.SerialNumbers?.join(", ") || "",
                });
            } else {
                console.error("❌ No data in response:", response);
                showMessage(response?.message || `Stock return ${returnId} not found`, "error");
                setIsEditMode(false);
            }
        } catch (error: any) {
            console.error("❌ Fetch error:", error.response?.data || error.message);
            showMessage("Failed to load stock return data", "error");
            setIsEditMode(false);
        } finally {
            setLoading(false);
        }
    };

    const parseSerialNumbers = (serialNumbersString: string): string[] => {
        if (!serialNumbersString?.trim()) return [];
        return serialNumbersString
            .split(",")
            .map((num) => num.trim())
            .filter((num) => num !== "");
    };

    const handleSerialNumberScan = useCallback((event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const target = event.target as HTMLTextAreaElement;
        const text = target.value;

        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();

            const lines = text.split('\n');
            const lastLine = lines[lines.length - 1].trim();

            if (lastLine && !text.includes(lastLine + ',')) {
                const updatedText = text ? `${text},${lastLine}`.trim() : lastLine;
                setValue("SerialNumbers", updatedText);

                setTimeout(() => {
                    target.focus();
                    target.setSelectionRange(updatedText.length, updatedText.length);
                }, 10);

                showMessage(`Scanned: ${lastLine}`, "info");
                setIsScanning(true);
                setTimeout(() => setIsScanning(false), 3000);
            }
        }
    }, [setValue, showMessage]);

    const toggleScanningMode = () => {
        setIsScanning(!isScanning);
        if (!isScanning && textareaRef.current) {
            textareaRef.current.focus();
            showMessage("🔍 Scanning mode ON - Scan QR codes now!", "info");
        } else {
            showMessage("Scanning mode OFF", "info");
        }
    };

    const onSubmit = async (data: any) => {
        try {
            setLoading(true);
            const quantity = parseInt(data.Quantity) || 0;
            const serialNumbersArray = parseSerialNumbers(data.SerialNumbers);

            // ✅ FIX 1: Make TechnicianId optional (matches API)
            if (!data.TechnicianId) {
                showMessage("Please select a technician or clear the field", "warning");
                setLoading(false);
                return;
            }

            const requestBody: StockReturnData = {
                ItemId: data.ItemId || "",
                WarehouseId: data.WarehouseId || "",
                TechnicianId: data.TechnicianId || "", // ✅ Send empty string if null
                Quantity: quantity,
                ReturnType: data.ReturnType || "",
                Remarks: data.Remarks?.trim() || "",
                SerialNumbers: serialNumbersArray, // ✅ Empty array if no serials
            };

            console.log("🚀 Sending Request:", requestBody); // ✅ Debug log

            let response;
            if (isEditMode && id) {
                response = await callAPI(`stockreturn/${id}`, Method.PATCH, requestBody);
            } else {
                response = await callAPI("stockreturn/", Method.POST, requestBody);
            }

            console.log("📡 API Response:", response); // ✅ Debug response

            if (response?.success) {
                showMessage(
                    isEditMode ? "Stock return updated successfully!" : "Stock return created successfully!",
                    "success"
                );
                navigate("/stock-return/list");
            } else {
                showMessage(response?.detail || response?.message || "Operation failed", "error");
            }
        } catch (error: any) {
            console.error("❌ Submit error:", error);
            showMessage(error?.detail || error?.message || "Operation failed", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = () => {
        if (!id) return;
        setSelectedId(id);
        setPopupOpen(true);
    };

    return (
        <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                    {isEditMode ? "Stock Return Details" : "Stock Return Management"}
                </Typography>
                <Box display="flex" gap={1}>
                    {isEditMode && (
                        <IconButton
                            sx={{ background: "black", color: "#fff" }}
                            onClick={handleDeleteClick}
                            disabled={loading}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    )}
                    <Tooltip title={isScanning ? "Stop Scanning" : "Start QR Scanning"}>
                        <IconButton
                            sx={{
                                background: isScanning ? "#4caf50" : "#2196f3",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: isScanning ? "#45a049" : "#1976d2"
                                }
                            }}
                            onClick={toggleScanningMode}
                            disabled={loading}
                        >
                            <QrCodeScannerIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <Paper
                sx={{
                    borderRadius: "16px",
                    p: 3,
                    background: "#fafafa",
                    position: "relative"
                }}
            >
                {loading && (
                    <Box sx={{
                        position: "absolute",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(255,255,255,0.9)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        zIndex: 10, borderRadius: "16px"
                    }}>
                        <CircularProgress />
                    </Box>
                )}

                <Box display="flex" justifyContent="space-between" mb={7}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
                        {isEditMode ? "Edit Stock Return" : "New Stock Return"}
                        {isScanning && (
                            <Typography
                                component="span"
                                sx={{
                                    color: "#4caf50",
                                    fontSize: "14px",
                                    ml: 1,
                                    fontWeight: 500
                                }}
                            >
                                🔍 SCANNING...
                            </Typography>
                        )}
                    </Typography>
                    <Tooltip title={isEditMode ? "Update Stock Return" : "Create Stock Return"} arrow>
                        <IconButton
                            sx={{ background: "#000", color: "#fff" }}
                            onClick={handleSubmit(onSubmit)}
                            disabled={!isValid || loading}
                        >
                            <SaveIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Grid container rowSpacing={8} columnSpacing={5}>
                    <Grid item xs={4}>
                        <WSSelectField
                            name="ItemId"
                            label="Item Name"
                            id="ItemId"
                            control={control}
                            inlineSearch
                            matchAnyWord
                            options={items.map(item => ({
                                value: item.ItemId,
                                label: item.ItemName
                            }))}
                        />
                    </Grid>

                    <Grid item xs="auto" display="flex" alignItems="flex-start" sx={{ pl: '12px !important' }}>
                        <Box
                            onClick={() =>
                                navigate("/stock-return/itemmaster", { state: { from: "stock-return" } })
                            }
                            sx={{
                                height: "36px",
                                width: "36px",
                                borderRadius: "10px",
                                background: "#f3f3f3",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                flexShrink: 0,
                                border: "1px solid #d1d5db",
                                "&:hover": {
                                    background: "#e0e0e0",
                                },
                            }}
                        >
                            <AddIcon fontSize="small" />
                        </Box>
                    </Grid>

                    <Grid item xs={4}>
                        <WSSelectField
                            name="WarehouseId"
                            label="Warehouse"
                            id="WarehouseId"
                            control={control}
                            inlineSearch
                            options={warehouses.map(warehouse => ({
                                value: warehouse.WarehouseId,
                                label: warehouse.WarehouseName
                            }))}
                        />
                    </Grid>

                    <Grid item xs="auto" display="flex" alignItems="flex-start" sx={{ pl: '12px !important' }}>
                        <Box
                            onClick={() =>
                                navigate("/stock-return/warehouse", { state: { from: "stock-return" } })
                            }
                            sx={{
                                height: "36px",
                                width: "36px",
                                borderRadius: "10px",
                                background: "#f3f3f3",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                flexShrink: 0,
                                border: "1px solid #d1d5db",
                                "&:hover": {
                                    background: "#e0e0e0",
                                },
                            }}
                        >
                            <AddIcon fontSize="small" />
                        </Box>
                    </Grid>


                    <Grid item xs={4}>
                        <WSSelectField
                            name="TechnicianId"
                            label="Technician Name"
                            id="TechnicianId"
                            control={control}
                            inlineSearch
                            options={technicians.map(technician => ({
                                value: technician.TechnicianId,
                                label: technician.TechnicianName
                            }))}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <WSTextField
                            name="Quantity"
                            label="Quantity"
                            id="Quantity"
                            control={control}
                            type={TextType.AllowOnlyNumber}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <WSSelectField
                            name="ReturnType"
                            label="Return Type"
                            id="ReturnType"
                            control={control}
                            options={config.ReturnTypeConfig.staticOptionData}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <WSSelectField
                            name="Customer"
                            label="Customer"
                            id="Customer"
                            control={control}
                            inlineSearch
                            options={customers.map(c => ({
                                value: c.CustomerId,
                                label: c.CustomerName
                            }))}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <WSTextAreaField
                            name="SerialNumbers"
                            label="Serial Numbers"
                            id="SerialNumbers"
                            control={control}
                            inputRef={textareaRef}
                            onKeyDown={handleSerialNumberScan}
                            // helperText={
                            //     watchedQuantity 
                            //         ? `Enter/scan exactly ${watchedQuantity} serial numbers (comma separated). Scanned: ${parseSerialNumbers(watchedSerialNumbers || "").length}/${watchedQuantity}`
                            //         : "Enter/scan serial numbers (comma separated) or press Enter after each QR scan"
                            // }
                            rows={4}
                            disabled={loading}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <WSTextAreaField
                            name="Remarks"
                            label="Remarks"
                            id="Remarks"
                            control={control}
                            rows={4}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <ConfirmationPopup
                type="DELETE"
                apiUrl="stockreturn"
                id={selectedId}
                confirmMessage="Are you sure you want to delete this stock return?"
                open={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                onConfirm={(data: any) => {
                    if (!selectedId) return;
                    if (data?.success === true) {
                        showMessage("Stock return deleted successfully!", "success");
                        navigate("/stock-return/list");
                    } else {
                        showMessage(data?.detail || "Delete failed", "error");
                    }
                    setPopupOpen(false);
                }}
            />
        </Box>
    );
};

export default StockReturn;